export enum MuMapActions {
  SEND_ADDRESS,
  FAIL_GET_ADDRESS,
  CLICK_MARKER,
}
